import { render, staticRenderFns } from "./SearchBarFirestore.vue?vue&type=template&id=2845ca5d&scoped=true"
import script from "./SearchBarFirestore.vue?vue&type=script&lang=js"
export * from "./SearchBarFirestore.vue?vue&type=script&lang=js"
import style0 from "./SearchBarFirestore.vue?vue&type=style&index=0&id=2845ca5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2845ca5d",
  null
  
)

export default component.exports